<template>
	<div class="container-fluid container-lg">
		<div class="row">
			<div class="col px-0" :class="{ 'col-lg-8': $slots.summary }">
				<ProductPageHeader :vm="vm" :showTeachingsMaterialButton="showTeachingsMaterialButton" />
				<Message v-if="!vm.availableInCurrentMarket" :closable="false" severity="error">
					{{ $t("common.productUnavailableInMarket") }}
				</Message>
				<ProductNewVersionBanner v-if="vm.latestVersionOfProduct" :vm="vm.latestVersionOfProduct" />
				<ProductPageContentSection v-if="$slots.configuration">
					<slot name="configuration" />
				</ProductPageContentSection>
				<template v-else-if="$slots.tabs">
					<slot name="tabs" />
				</template>
				<!-- Default content goes here-->
				<slot />
			</div>
			<div v-if="$slots.summary" class="col-lg-4" :class="{ 'sticky-bottom-panel': isSmallScreen }">
				<slot name="summary" />
			</div>
		</div>
	</div>
	<Sidebar v-model:visible="showSideBar" class="p-sidebar-md p-sidebar-primary" position="left">
		<div v-for="(item, index) in helpBlock?.items" :key="index">
			<h3 v-if="item.title" v-html="item.title"></h3>
			<p v-html="item.text"></p>
		</div>
		<SupportCard />
	</Sidebar>
</template>

<script lang="ts">
	import BaseComponent from "@/components/base/baseComponent.vue";
	import ProductPageContentSection from "@/components/product/productPageContentSection.vue";
	import ProductPageHeader from "@/components/product/productPageHeader.vue";
	import Sidebar from "primevue/sidebar";
	import SupportCard from "@/components/commerce/supportCard.vue";
	import ProductNewVersionBanner from "@/components/product/productNewVersionBanner.vue";
	import { Component, Model, Prop } from "vue-facing-decorator";
	import { HelpBlockViewModel } from "@/types/generated/Common/helpBlockViewModel";
	import { IProductViewModel } from "@/types/models/common/productViewModel.interface";
	import { ProductServiceType } from "@/types/enum/productServiceType";
	import { PropType } from "vue";
	import { Log } from "@/types/helpers/logHelper";
	import { buildStructuredData } from "@/types/utils/seo/structuredData/structuredData";

	@Component({
		emits: ["update:modelValue"],
		components: {
			ProductNewVersionBanner,
			ProductPageHeader,
			ProductPageContentSection,
			SupportCard,
			Sidebar,
		},
	})
	export default class ProductLayout extends BaseComponent {
		@Prop({ type: Object as PropType<IProductViewModel>, required: true, default: {} })
		vm!: IProductViewModel;

		@Prop({ type: Object as PropType<HelpBlockViewModel>, required: false, default: {} })
		helpBlock!: HelpBlockViewModel;

		@Prop({ type: Boolean, required: false, default: false }) showTeachingsMaterialButton!: boolean;

		@Model({ type: Boolean, required: false, default: false }) showSideBar!: boolean;

		created() {
			Log.log("ProductLayout", this.vm);
		}

        mounted() {
            buildStructuredData({ vm: this.vm, origin: location.origin, currentPath: location.pathname });
		}

		get productCategory(): string {
			return this.vm.serviceType === ProductServiceType.ownSoftware ||
				this.vm.serviceType === ProductServiceType.thirdPartySoftware
				? "SoftwareApplication"
				: ProductServiceType[this.vm.serviceType];
		}

		get creator(): string {
			return this.vm.brand != null ? this.vm.brand : "Cadac Group"
		}
	}
</script>

<style scoped lang="scss">
	:deep(.product-tabs-header) {
		top: var(--navbarHeightInPx);
	}

	.shadow-left {
		box-shadow: -5px 0px 5px 1px #dddd;
	}

    .sticky-bottom-panel {
        position: sticky;
        bottom: 0;
        left: 0;
        z-index: 101;
        background: var(--surface-a);
        box-shadow: 0px -4px 8px -7px rgba(0, 0, 0, 0.75);
    }
</style>
